import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataShareService } from '../../../services/data-share.service';
import { AccountMembership } from '../../API.service.custom';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-subscribe',
    templateUrl: './subscribe.component.html',
    styleUrls: ['./subscribe.component.scss'],
    imports: [FormsModule, NgxIntlTelInputModule]
})
export class SubscribeComponent implements OnInit, AfterViewInit  {
  activAccountSubscription;
  allAccountMembersSubscription;
  activeAccount : AccountMembership = null;
  allAccountMemberships : AccountMembership[] = [];
  firstName : String = "";
  lastName : String = "";
  planType = "monthly";

  constructor(
    private dataService: DataShareService,
    private router: Router,
    private toastr: ToastrService,
) { }

  ngOnInit() {
    const bodyElement = document.body;
    if (bodyElement) {
      bodyElement.classList.add("subscribe-class");
    }
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
          this.activeAccount = param;
          let name = param.user.name;
          this.firstName = name.split(' ').slice(0, -1).join(' ');
          this.lastName = name.split(' ').slice(-1).join(' ');
      }
    })

    this.allAccountMembersSubscription = this.dataService.getAllIncludingInactiveUsersInAccount().subscribe((param: any) => {
      if (param) {
          this.allAccountMemberships = param;
      }
    })
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
        this.activAccountSubscription.unsubscribe();
      if (this.allAccountMembersSubscription && !this.allAccountMembersSubscription.closed)
        this.allAccountMembersSubscription.unsubscribe();
  }

  onItemChange(value){
    console.log(" Value is : ", value );
    this.planType = value;
 }

  viewMembers(){
    this.router.navigate(['/admin/users']);
  }

  ngAfterViewInit(): void {
    // Chargebee widgets have been removed; nothing to re-register.
  }


  subscribe() {
    this.toastr.info('Subscription checkout is no longer available in-app. Please contact support to manage billing.');
  }

  manage() {
    this.toastr.info('Billing portal has moved. Please contact support for subscription changes.');
  }
}

